
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1245_1532)"}},[_c('path',{attrs:{"d":"M30 0H0v20h30V0z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.167 7.273V0h5.5v7.273H33v5.454H14.667V20h-5.5v-7.273H0V7.273h9.167z","fill":"#002F6C"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1245_1532"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h30v20H0z"}})])])])
          )
        }
      }
    